<div *ngIf="visible" class="bulk-selection-banner" role="status" aria-live="polite">
    <div class="bulk-selection-banner__copy">
        <span class="bulk-selection-banner__count">{{ selectionCopy }}</span>
        <button
                *ngIf="showSelectAllMatching && mode === 'page' && matchingCount > selectedCount"
                type="button"
                class="bulk-selection-banner__link"
                (click)="onSelectAllMatching()">
            Select all {{ matchingCount }} matching {{ itemLabel }}
        </button>
        <button
                type="button"
                class="bulk-selection-banner__link bulk-selection-banner__clear"
                (click)="onClearSelection()">
            Clear selection
        </button>
    </div>
    <div class="bulk-selection-banner__actions">
        <ng-content select="[bulkSelectionActions]"></ng-content>
    </div>
</div>
